export default function checkIsEven(n: number): boolean {
	return n % 2 === 0;
}
